/* eslint-disable jsx-a11y/media-has-caption */
import { Grid2, Typography } from "@mui/material";

interface Props {
  message?: string;
}

const Loader = ({ message }: Props) => {
  return (
    <div
      style={{
        position: "absolute",
        zIndex: 9999,
        background: `#EEF5F6`,
        height: "100vh",
        width: "100vw",
      }}
    >
      <Grid2
        container
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
        height={"100%"}
      >
        <img
          src="/Logos/GridkeyGif.gif"
          alt=" "
          height={100}
          width={100}
          style={{
            filter: `drop-shadow(0px 0px 3px #00000077)`,
          }}
        />

        <Typography fontWeight={700} fontSize={16} color={"var(--black)"}>
          {message || " Your Experience is Worth the Wait!"}{" "}
        </Typography>
      </Grid2>
    </div>
  );
};

export default Loader;
